import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { WhoWeLookForScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'

const AgeOfRequestedFrom: React.FC<FieldProps<WhoWeLookForScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <div className='margin-top-m palm-one-whole lap-one-half desk-one-half lap-padding-right-m desk-padding-right-m'>
      <TextInput
        id='age-of-requested-from'
        propertyName='ageOfRequestedFrom'
        label={<>{t('wizard.screen.whoWeLookFor.labels.ageOfRequestedFrom', 'Age of requested from')}</>}
        placeholder=''
        value={insertionData.ageOfRequestedFrom}
        type='tel'
        maxLength={3}
        errors={validationMessages?.ageOfRequestedFrom ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default AgeOfRequestedFrom
